import './src/styles/global.css'
import { wrapPageElement as wrapPageElementHelper } from './src/utils/gatsby'

// Handle reCAPTCHA timeout promise rejections
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    // Handle reCAPTCHA timeout errors gracefully
    if (event.reason === 'Timeout') {
      event.preventDefault()
      console.warn('reCAPTCHA timeout occurred, this is expected behavior')
    }
  })
}

// eslint-disable-next-line import/prefer-default-export
export const wrapPageElement = wrapPageElementHelper
